import * as React from 'react';

import { HtmlRenderer, Parser } from 'commonmark'

import VttFooter from '../../../api/footerEntity';

interface IProps {
  footer: VttFooter;
  fetchFooter(): void;
}

export class Footer extends React.Component<IProps,{}> {
  public componentDidMount() {
    this.props.fetchFooter();
  }

  public render() {

    const parser = new Parser()
    const renderer = new HtmlRenderer()
    const content = renderer.render(parser.parse(this.props.footer.content))

    return (
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 footer-left" dangerouslySetInnerHTML={ {__html: content} } />
                        <div className="col-md-4 footer-right">
                            <div className="logo">
                                <img src={this.props.footer.logoImage} />
                            </div>
                        </div>
                    </div>
                </div>
    );
  }
};


// WEBPACK FOOTER //
// ./src/common/components/footer/footer.tsx